module.exports={"flag":"","geoJSON":{},"ISO":{},"provinces":["Holy See (Vatican City)"],"tld":[],"wiki":"http://en.wikipedia.org/wiki/holy_see_vatican_city"}